import { render, staticRenderFns } from "./ArtworkSidebarElement.vue?vue&type=template&id=261f39e3&"
import script from "./ArtworkSidebarElement.vue?vue&type=script&lang=js&"
export * from "./ArtworkSidebarElement.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkSidebarElement.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports